import API_BASE_URL from "../config/apiConfig"; // Adjust this path based on your folder structure

export const performLogout = async (navigate) => {
  try {
    // ✨ FIX: Use the centralized API URL
    await fetch(`${API_BASE_URL}/api/auth/logout`, {
      method: "POST",
      credentials: "include" // MUST include this to send the cookie!
    });
    
  } catch (error) {
    console.error("Error during backend logout:", error);
  } finally {
    // Clean up any old leftover localStorage items just in case
    localStorage.removeItem("authToken");
    localStorage.removeItem("token");
    localStorage.removeItem("firstName");
    localStorage.removeItem("lastName");
    localStorage.removeItem("userRole");
    
    if (navigate) {
      navigate('/log-in'); 
    } else {
      window.location.href = '/log-in';
    }
  }
};